import { render, staticRenderFns } from "./redirectCenterLink.vue?vue&type=template&id=0a73a658&scoped=true&"
import script from "./redirectCenterLink.vue?vue&type=script&lang=js&"
export * from "./redirectCenterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a73a658",
  null
  
)

export default component.exports